import { LoggerUtil } from 'core/utils/loggerUtil.ts';

export const metaAnalyticsUtil = (event, params = {}) => {
	if (typeof window.fbq !== 'undefined') {
		try {
			window.fbq('track', event, params);
		} catch (error) {
			LoggerUtil.logWarning('Error triggering Meta Pixel event');
		}
	} else {
		LoggerUtil.logWarning(
			'Meta Pixel (fbq) is not defined. Make sure the Meta Pixel script is loaded.',
		);
	}
};
